let icons: any[] = [];
let faIcons: any[] = [];

export class IconService {

    public async getIcons() {
        if (icons.length > 0) {
            return icons;
        }

        icons = await fetch('/data/icons.json', {headers: {'Cache-Control': 'no-cache'}})
            .then((res) => res.json());

        return icons;
    }

    public async getFontAwesomeIcons() {
        if (faIcons.length > 0) {
            return faIcons;
        }

        faIcons = await fetch('/data/fa-icons.json', {headers: {'Cache-Control': 'no-cache'}})
            .then((res) => res.json());
        return faIcons;
    }

    public async getIcon(id: any) {
        if (icons) {
            return (await this.getIcons()).find((x) => x.properties.id === id);
        }
    }

}